/**
 * Created by tigran on 18.01.25
 **/

import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const DocsIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5714 3.92859L3.42859 3.92859L3.42859 21.0714L20.5714 21.0714L20.5714 3.92859Z"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M3.42859 12.5L20.5714 12.5"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M10.2857 7.35718L13.7143 7.35718"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M10.2857 15.9286H13.7143"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
    </svg>
  );
};
